import { render, staticRenderFns } from "./IngredientListElement.vue?vue&type=template&id=72804a0e&scoped=true"
import script from "./IngredientListElement.vue?vue&type=script&lang=js"
export * from "./IngredientListElement.vue?vue&type=script&lang=js"
import style0 from "./IngredientListElement.vue?vue&type=style&index=0&id=72804a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72804a0e",
  null
  
)

export default component.exports